import { defineView } from "@knyt/weaver";
import { globalComponentRegistry, } from "./ComponentControllerRegistry.js";
/**
 * @deprecated This is an experimental API that will change in the future.
 */
// TODO: Add overload to support the `root` option as a the first argument
export function defineComponent(options) {
    return defineView(globalComponentRegistry.createViewRenderer(options), {
        debug: options.debug,
    });
}
